import React, { FunctionComponent } from 'react';
import { Dialog as MuiDialog, Typography } from '@mui/material';
import cx from 'classnames';
import CircularButton from '../CircularButton/CircularButton';
import useStyles from './Dialog.styles';

interface IProps {
  id: string;
  title: string;
  open: boolean;
  onClose?: () => void;
  submitBtnText?: string;
  cancelBtnText?: string;
  onSubmitBtnClick?: () => void;
  onCancelBtnClick?: () => void;
  customClass?: string;
  closeOnSubmit?: boolean;
  isSubmitBtnDisabled?: boolean;
}

const Dialog: FunctionComponent<IProps> = ({
  children,
  id,
  title,
  open,
  onClose,
  submitBtnText = 'Save',
  cancelBtnText = 'Cancel',
  onSubmitBtnClick,
  onCancelBtnClick,
  closeOnSubmit = true,
  customClass = '',
  isSubmitBtnDisabled = false,
}) => {
  const classes = useStyles();
  const onCancelClick = () => {
    if (onClose) onClose();
    if (onCancelBtnClick) onCancelBtnClick();
  };

  const onSubmitClick = () => {
    if (closeOnSubmit && onClose) onClose();
    if (onSubmitBtnClick) onSubmitBtnClick();
  };

  return (
    <div>
      <MuiDialog
        open={open}
        PaperProps={{ id }}
        classes={{
          paper: cx(classes.container, { [customClass]: customClass }),
        }}
        onClose={onClose}
      >
        <Typography
          variant="h2"
          className={classes.title}
          data-testid={`${id}__title`}
        >
          {title}
        </Typography>
        <div className={classes.content} data-testid={`${id}__body`}>
          {children}
        </div>
        <div className={classes.actions} data-testid={`${id}__actions`}>
          <CircularButton
            type="button"
            color="primary"
            customClass={classes.cancelBtn}
            onClick={onCancelClick}
            data-testid={`${id}__cancel`}
          >
            {cancelBtnText}
          </CircularButton>
          <CircularButton
            type="button"
            color="primary"
            variant="contained"
            customClass={classes.acceptBtn}
            onClick={onSubmitClick}
            data-testid={`${id}__accept`}
            disabled={isSubmitBtnDisabled}
          >
            {submitBtnText}
          </CircularButton>
        </div>
      </MuiDialog>
    </div>
  );
};

export default Dialog;
